import { Component, OnDestroy, OnInit } from '@angular/core';
import { InventoryStockTransferDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/InventoryStockTransfers/inventory-stock-transfer-dto';
import { InventoryActionStatus } from 'src/app/pos-panel/enums/inventory-action-status.enum';
import { InventoryService } from 'src/api/generated/services';
import { ActivatedRoute, Router } from '@angular/router';
import { CurrentVenueHelperService } from 'src/app/share-modul/services/current-venue-helper/current-venue.helper.service';
import { GetStockTransfer$Params } from 'src/api/generated/fn/inventory/get-stock-transfer';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { CancelStockTransfer$Params } from 'src/api/generated/fn/inventory/cancel-stock-transfer';
import { Subscription } from 'rxjs';
import { InventoryDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Inventory/inventory-dto';
import { GetInventory$Params } from 'src/api/generated/fn/inventory/get-inventory';

@Component({
  selector: 'app-outgoing-transfer-details',
  templateUrl: './outgoing-transfer-details.component.html',
  styleUrls: ['./outgoing-transfer-details.component.scss']
})
export class OutgoingTransferDetailsComponent implements OnInit, OnDestroy {

  venueId: string;
  inventoryId: string;
  transferId: string;
  inventory: InventoryDto;
  
  transfer: InventoryStockTransferDto = {} as InventoryStockTransferDto;  
  venueIdUpdateSubscription: Subscription;
  InventoryActionStatus = InventoryActionStatus;
  timezoneOffset: any;

  constructor(
              private router: Router,
              private inventoryService: InventoryService,
              private route: ActivatedRoute,
              private currentVenueHelper: CurrentVenueHelperService,
              private confirmationService: ConfirmationService,
              public translate: TranslateService,
              private messageService: MessageService) {

  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params['venue-id'] != null) {
        this.venueId = params['venue-id'];
        this.currentVenueHelper.updateCurrentVenueIdDropdown(params['venue-id']);
        this.currentVenueHelper.getTimezone().subscribe(tzOffset => this.timezoneOffset = tzOffset);
      }
      if (params['inventory-id'] != null && params['transfer-id'] != null) {
        this.inventoryId = params['inventory-id'];
        this.transferId = params['transfer-id'];

        const inventoryParams: GetInventory$Params = { inventoryId: this.inventoryId };
        this.inventoryService.getInventory(inventoryParams).subscribe(response => this.inventory = response);
        
        const transferParams: GetStockTransfer$Params = { inventoryId: this.inventoryId, transferId: this.transferId };
        this.inventoryService.getStockTransfer(transferParams).subscribe( response => {
          this.transfer = response;
        });
      }
    });
  }
  cancelTransfer(){
    this.confirmationService.confirm({
      header: this.translate.instant('TRANSFER.CONFIRMATION_DIALOG_CANCEL_TRANSFER_TITLE'),
      message: this.translate.instant('TRANSFER.CONFIRMATION_DIALOG_CANCEL_TRANSFER_QUESTION'),
      acceptLabel: this.translate.instant('YES'),
      rejectLabel: this.translate.instant('NO'),
      defaultFocus: "reject",
      acceptButtonStyleClass: 'soc-confirmation-dialog dialog-btn destructive-btn',
      rejectButtonStyleClass: 'soc-confirmation-dialog dialog-btn reject-btn',
      accept: () => {
        const params: CancelStockTransfer$Params = { inventoryId: this.inventoryId, transferId: this.transferId };
        this.inventoryService.cancelStockTransfer(params).subscribe({
          next: response => {
            this.messageService.add({severity:'success', summary:'Transfer was succesfully cancelled!', life:3000});
            this.navigateToMain();
          },
          error: errorResponse => {
              this.messageService.add({severity:'error', summary:'Error occurred! ', life:3000})

          }
        });
      }
    });

  }

  navigateToMain() {
    if(this.inventory.isMain){
      this.router.navigate([this.venueId, "inventory", this.inventoryId], { queryParams: { activeIndex: 3 }}); 
    }else{
      this.router.navigate([this.venueId, "inventory", this.inventoryId], { queryParams: { activeIndex: 2 }}); 
    }
  }
  public ngOnDestroy(): void {
    if (this.venueIdUpdateSubscription) {
      this.venueIdUpdateSubscription.unsubscribe();
    }
  }

}
